import { ThemeProvider as DSThemeProvider, lightTheme, Loading } from '@shape-ds/components';
import { useReportPDFQuery } from 'queries/report/queries';
import { MainPage } from './MainPage/MainPage';
import './style.scss';
import Cover from './Cover/Cover';
import { Dayjs } from 'lib';
import { ThirdPage } from './ThirdPage/ThirdPage';
import { SecondPage } from './SecondPage/SecondPage';

export const Pdf: React.FC<{
  asset: { id: string; name: string };

  date: Dayjs;
  assetsCategory?: string;
  setIsLoading?: (isLoading: boolean) => void;
}> = ({ asset, date, assetsCategory = 'RERT' }) => {
  const { data, isLoading } = useReportPDFQuery({
    assetId: asset.id,
    month: (date.month() + 1).toString(),
    year: date.year().toString(),
  });

  if (isLoading || !data) {
    return <Loading center />;
  }
  const formattedDate = date.format('MMMM, YYYY');
  return (
    <>
      <Cover
        asset={asset}
        assetDescription={data.description}
        date={formattedDate}
        category={assetsCategory}
      />
      <DSThemeProvider theme={lightTheme}>
        <MainPage data={data} date={formattedDate} category={assetsCategory} />
        <SecondPage data={data} date={formattedDate} category={assetsCategory} />
        <ThirdPage data={data} date={formattedDate} category={assetsCategory} />
      </DSThemeProvider>
    </>
  );
};
